'use client';

import { TextField } from '@mui/material';
import { useMemo, useState } from 'react';

import { formatNumber } from '../../../../../utils/src/formatNumber';
import { NumberInputProps } from '../types';

export function NumberInput(props: NumberInputProps) {
  const [focused, setFocused] = useState(false);

  const inputType = props.formatOnBlur
    ? focused
      ? 'number'
      : 'text'
    : 'number';

  const isReadOnly = props?.readOnly ?? false;

  const displayValue = useMemo(() => {
    const v = props.value;
    if (v === null || v === undefined) return '';
    if (props.formatOnBlur && !focused) {
      return formatNumber(v, {
        asCurrency: props.asCurrency,
        locale: props.locale,
        currency: props.currency,
      });
    }
    return String(v);
  }, [
    props.value,
    props.formatOnBlur,
    props.asCurrency,
    props.locale,
    props.currency,
    focused,
  ]);

  return (
    <TextField
      fullWidth
      name={props.name}
      type={inputType}
      label={`${props.label}${isReadOnly ? ' (Read Only)' : ''}`}
      value={displayValue}
      onFocus={() => setFocused(true)}
      onBlur={() => {
        setFocused(false);
        props.onBlur?.();
      }}
      onChange={(e) => {
        const val = e.target.value;
        if (val === '') {
          props.onChange(null);
          return;
        }
        const next = Number(val.replace(/[^0-9.\-]/g, ''));
        props.onChange(Number.isNaN(next) ? null : next);
      }}
      error={!!props.error}
      helperText={props.error}
      slotProps={{
        input: {
          inputProps: {
            min: props.min,
            max: props.max,
            step: props.step,
          },
        },
      }}
      InputProps={{ readOnly: props.readOnly }}
    />
  );
}
